import { useQuery, useInfiniteQuery } from "react-query";
import {
  getIndexTransactions,
  getListPaymentMethods,
  getOneTransaction,
  getSessionParking,
} from "~/services/payment.service";
import {
  IGetTransactionsParam,
  ITransactionV3,
  IOptionSessionParking,
} from "~/lib/types/payment.type";
import { GetOneTransaction } from "~/lib/types/variables.type";

const PAYMENTS_QUERY_KEY = {
  INDEX_TRANSACTIONS: "INDEX_TRANSACTIONS",
  ONE_TRANSACTION: " ONE_TRANSACTION",
  GET_ARTICLE_BY_SECTION: "GET_ARTICLE_BY_SECTION",
  GET_SESSION_PARKING: "GET_SESSION_PARKING",
  GET_LIST_PAYMENT_METHOD: "GET_LIST_PAYMENT_METHOD",
} as const;

// adding isPayment boolean to filter between payments and mesra transactions
export const useIndexTransactions = (params?: IGetTransactionsParam) =>
  useQuery(
    [PAYMENTS_QUERY_KEY.INDEX_TRANSACTIONS, params],
    () =>
      getIndexTransactions(params).then((res) =>
        res.map((item: ITransactionV3) => ({ ...item, isPayment: true }))
      ),
    {
      enabled: params?.enabled,
    }
  );

export const useInfiniteTransactions = (params?: IGetTransactionsParam) =>
  useInfiniteQuery(
    ["infinite", PAYMENTS_QUERY_KEY.INDEX_TRANSACTIONS, params],
    ({ pageParam }) =>
      getIndexTransactions({ ...params, page: Number(pageParam) }).then((res) =>
        res.map((item: ITransactionV3) => ({ ...item, isPayment: true }))
      ),
    {
      enabled: params?.enabled,
      getNextPageParam: (lastPage, pages) =>
        pages[pages.length - 1].length ? pages.length + 1 : undefined,
    }
  );

export const useOneTransaction = (params?: GetOneTransaction) =>
  useQuery(
    [PAYMENTS_QUERY_KEY.ONE_TRANSACTION, params],
    () =>
      getOneTransaction(params).then((res) => ({ ...res, isPayment: true })),
    {
      enabled: params?.enabled,
    }
  );

export const useSessionParking = (
  referenceId: string,
  option: IOptionSessionParking
) =>
  useQuery(
    [PAYMENTS_QUERY_KEY.GET_SESSION_PARKING, referenceId],
    () =>
      getSessionParking(referenceId).then((res) => res.session.locationName),
    option
  );

export const useGetListPaymentMethods = (params?: { enabled: boolean }) =>
  useQuery(
    [PAYMENTS_QUERY_KEY.GET_LIST_PAYMENT_METHOD, params],
    () => getListPaymentMethods(),
    {
      enabled: params?.enabled,
    }
  );
